import jQuery from 'jquery'
global.$ = jQuery
window.$ = jQuery

$(document).on('turbolinks:load', () => {
  $(function(){
    $('header .drawer-button, #drawer-button ,#drawer_menu .close span').click(function(){
      $("#drawer_menu").toggleClass('active');
    });
    $('#drawer_menu h2').click(function(){
      $(this).next('.nav02').slideToggle(120);
    });
    $('footer .nav02 .switch').click(function(){
      $(this).toggleClass('active');
    });
  });

});
